import { createEntityTouchSelect } from './helpers/createEntityTouchSelect';
import { useSalesOrdersList } from './SelectSalesOrder';

import {
  formatAddressDisplay,
  formatSalesOrderLabel,
} from '~/shared/utils/salesOrderFormatting';

export const SelectSalesOrderTouch = createEntityTouchSelect.remotelySearched(
  'SelectSalesOrder',
  useSalesOrdersList,
  {
    formatLabel: formatSalesOrderLabel,
    formatSubLabel: (entity) =>
      entity.shippingAddress
        ? formatAddressDisplay(entity.shippingAddress)
        : '',
  },
);
